import React from 'react';
import {Link, withPrefix} from 'gatsby';
import Layout from '../../../../components/Layout';
import SEO from '../../../../components/seo';

import {main} from '../../../../data/yatagan/main';
import {imgs} from '../../../../data/yatagan/yatagan-img-map';

export default class IndexPage extends React.Component {
  render() {
    const mainCategories = JSON.parse(main);
    const imgArray = JSON.parse(imgs);
    const commonLink='/catalog/yatagan/catalog';
    return (
    <Layout>
      <SEO title='Каталог воздухоочистного оборудования Ятаган' />
      <div id="main" className='catalog'>
        <div className="inner">
          <h1>Воздухоочистное оборудование Ятаган</h1>
          <section className='categories'>
            <div className="box alt">
              <div className="row gtr-uniform">
                {mainCategories && mainCategories.map((item, i) => {
                  // console.log('item ', item);
                  const link = `${commonLink}/${item.alias}`;
                  const imgName = imgArray.filter(img => img.type === 'main' && img.alias === item.alias)[0]['img'];
                  const img = withPrefix(`/img/yatagan/main/${item.alias}/${imgName}`);
                  return <div key={i} className="col-sm-12 col-md-4 category-item">
                    <Link to={link}>
                      <div className="image fit">
                        <img src={img} alt={item.title} />
                      </div>
                      <h3>{item.title}</h3>
                    </Link>
                  </div>
                })}
              </div>
            </div>
          </section>
        </div>
      </div>
    </Layout>
    )
  }
}
